import { payloadSchema } from '@/schemas'
import type { ContractInterface } from '@/types'

import type { ContractEditFormType } from '../Contracts.config'
import type { UpdateContractRequest } from '../types/contracts.types'

export const toUpdateContractRequest = (
  values: ContractEditFormType,
  contract: ContractInterface,
  currencyId: string
): UpdateContractRequest => ({
  description:
    contract.description || `Договор от ${new Date().toLocaleDateString()}`,
  number: values.number,
  currency: currencyId,
  isActive: values.isActive,
  paymentType: values.paymentType.value,
})

export const getContractPayloadError = (payload: UpdateContractRequest) => {
  const result = payloadSchema.safeParse(payload)
  if (result.success) return null
  const [firstError] = result.error.errors
  return `${firstError.path.join('.')}: ${firstError.message}`
}
